module.exports = __webpack_public_path__ + "img/smile--grey.0f42ce75.svg";